var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"user":_vm.user,"lang":_vm.lang,"isMobileDevice":_vm.isMobileDevice},on:{"toggleLanguage":_vm.toggleLanguage}}),_c('router-view',{attrs:{"user":_vm.user,"lang":_vm.lang,"isMobileDevice":_vm.isMobileDevice}}),(_vm.lang == 'ko')?_c('Footer'):(_vm.lang == 'en')?_c('Footer_En'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }